import React from 'react'
import useMediaQuery from 'utils/hooks/useMediaQuery';
import ExpirationCertificate from './components/ExpirationCertificate';
import CertificateLink from '../../../OtherAttributesAccordion/components/CertificateLink';
import { LG } from 'constants/breakpoints';
import { calculateCertificateFileExpired } from '../../../OtherAttributesAccordion/utils';

const RowWithCertificate = ({ certificateData }) => {
  const isMobile = useMediaQuery(LG)
  const { certificate, file_expires: expiresValue, file_not_expires: notExpiresValue  } = certificateData

  let resultExpiresValue;
  if (certificate)
    if (expiresValue || notExpiresValue) {
      resultExpiresValue = calculateCertificateFileExpired(expiresValue, notExpiresValue);
    }

  return (
    <>
      {certificate && (
        <>
          {" - "}
          <CertificateLink link={certificate} />
        </>
      )}

      {resultExpiresValue && " - "}

      {resultExpiresValue && (
        <div className="d-inline-block align-middle">
          <ExpirationCertificate
            expiredData={resultExpiresValue}
            onlyCircleWithoutText={isMobile}
          />
        </div>
      )}
    </>
  );
}

export default RowWithCertificate